<template>
  <div>
    <div class="flex flex-wrap lg-section ti-page-start pt2 pb1">
      <div class="sm-col md-col-5 px3 pb2">
        <h1 class="ti-h2">Vendor Connect</h1>
        <div class="ti-under"></div>
      </div>
      <div class="sm-col md-col-6 px3">
        <p class="ti-page-intro">
          Select Technologies and Sectors to view vendors in those areas.
        </p>
      </div>
    </div>

    <div v-if="!loading" class="lg-section flex px2">
      <div class="sm-col sm-col-12 md-col-5 pb3">
        <TreeFilter allLabel="All Sectors" headerClass="ti-tag-sector"
                    :listItems="$store.state.refMap.vertical_items"
                    :items="$store.state.refMap.verticals"
                    :filters="$store.state.verticals" :counts="counts.verticals"
                    @itemClick="toggleVerticalItem"
                    class="mt2"/>
        <TreeFilter allLabel="All Technologies" headerClass="ti-tag-technology"
                    :listItems="this.$store.getters.getTechKeys"
                    :items="$store.state.refMap.tech_areas"
                    :show="$store.state.refMap.connectTech"
                    :filters="$store.state.techs"
                    :counts="counts.techareas"
                    @itemClick="toggleTechItem"
                    :defs="TechDef"
                    class="mt2"/>
      </div>

      <div class="sm-col sm-col-12 md-col-6 ml2"
           style="position: sticky; top:10px; align-self: flex-start;">
        <div v-if="refreshing">...</div>
        <template v-else-if="vendors && vendors.length">
          <div v-for="vendor in vendors" :key="vendor.id"
               class="flex ti-row-highlight" style="padding: 6px 8px;">
            <input type="checkbox" class="check-disabled"
                   :checked="$store.state.compare[vendor.id]"
                   :disabled="disableCompareCheckbox(vendor.id)"
                   @change="toggleVendor(vendor.id, vendor.name)"/>
            <router-link :to="{name: 'connect-detail',
                              params: {id: vendor.id, slug:toSlug(vendor.name)}}"
                         class="flex-auto pl2 ti-link ti-link-underline"
                         style="color:black;">
              {{vendor.name}}
            </router-link>
          </div>
          <div class="mt2 right-align">
            <Paginate :totalPages="$store.state.page.totalPages"
                      :currentPage="$store.state.page.currentPage"
                      @goPage="goPage">
            </Paginate>
          </div>
        </template>
        <div v-else class="ti-p">
          &nbsp;No Matches
        </div>
        <div class="mt2">
          <router-link :to="{name: 'connect-compare', query: {vendors: compVendors}}"
                       tag="input" class="btn btn-primary"
                       :disabled="compVendors.length === 0 || compareSelectionMsg !== ''"
                       value="Compare Selected Vendors"
                       style="width:300px;"/>
          <div v-if="compVendors.length !== 0 && compareSelectionMsg"
               v-html="compareSelectionMsg" class="my1 ti-note">
          </div>
          <div v-if="compareSelectionLimitMsg"
               v-html="compareSelectionLimitMsg" class="my1 ti-note">
          </div>
          <ul class="my1">
            <li v-for="(vendorName, vendorId) in $store.state.compare"
                :key="vendorId" class="text-tag">
              {{vendorName}}<span class="text-tag-close"
                                  @click="toggleVendor(vendorId, '')"> ❌</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import TechDef from '@/tech';
import Paginate from '@/components/Paginate.vue';
import TreeFilter from '@/components/TreeFilter.vue';

export default {
  name: 'VendorList',
  components: { Paginate, TreeFilter },
  data() {
    return {
      TechDef,
      loading: true, // first load of refMap
      // refMap dicts for creating filters

      refreshing: true, // refreshing list of studies and counts
      vendors: null,
      counts: {
        verticals: {},
        techareas: {},
        techs: {},
      },
    };
  },

  computed: {
    compVendors() {
      return Object.keys(this.$store.state.compare);
    },
    compareSelectionMsg() {
      let msg = '';
      const vertLength = this.$store.getters.getSelectedVert.length;
      if (vertLength === 0) {
        msg += 'You must select a Sector to be compared (on left side).<br/>';
      } else if (vertLength !== 1) {
        msg += 'You must select <strong>only one</strong> Sector to be compared.<br/>';
      }
      const techLength = this.$store.getters.getSelectedTech.length;
      if (techLength === 0) {
        msg += 'You must select a Technology to be compared (on left side).<br/>';
      } else if (techLength !== 1) {
        msg += 'You must select <strong>only one</strong> Technology to be compared.<br/>';
      }
      return msg;
    },
    compareSelectionLimitMsg() {
      if (!this.canAddCompare()) {
        return 'A maximum of four vendors can be compared side-by-side.<br/>';
      }
      return null;
    },

  },

  created() {
    if (this.$store.state.refMap === null) {
      axios.get('/api/vendors/schema')
        .then((res) => {
          this.$store.commit('initMaps', res.data.refMap);
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
    const pageIndex = this.$store.state.page.currentPage || 1;
    this.getVendors(pageIndex);
  },

  methods: {
    getVendors(page = 1) {
      // get list of studies
      this.refreshing = true;
      const postData = {
        page,
        filters: {
          verticals: this.$store.state.verticals,
          techs: this.$store.state.techs,
        },
      };
      axios.post('/api/connect', postData)
        .then((res) => {
          this.vendors = res.data.vendors;
          this.$store.commit('setPage', res.data.page);
          this.counts = res.data.counts;
          this.refreshing = false;
        });
    },

    goPage(pageIndex) {
      this.getVendors(pageIndex);
    },

    toggleVerticalItem(param) {
      let payload;
      if (param === null) {
        payload = { property: 'verticals', val: null };
      } else {
        const current = Boolean(this.$store.state.verticals[param]);
        payload = { property: 'verticals', id: param, val: !current };
      }
      this.$store.commit('setFilter', payload);
      this.$nextTick().then(() => this.getVendors(1));
    },

    toggleTechItem(param) {
      let payload;
      if (param === null) {
        payload = { property: 'techs', val: null };
      } else {
        const current = Boolean(this.$store.state.techs[param]);
        payload = { property: 'techs', id: param, val: !current };
      }
      this.$store.commit('setFilter', payload);
      this.$nextTick().then(() => this.getVendors(1));
    },

    toggleVendor(vendorId, vendorName) {
      const payload = { id: vendorId, val: vendorName };
      this.$store.commit('toggleCompare', payload);
    },

    // there is a limit of 4 vendors to be compared at the same time
    canAddCompare() {
      return Object.keys(this.$store.state.compare).length < 4;
    },

    // There is a limit of for vendors to compare.
    // if already 4 selected (and not currently selected) disable it.
    disableCompareCheckbox(vendorId) {
      if (this.$store.state.compare[vendorId]) {
        return false;
      }
      return !this.canAddCompare();
    },
  },
};
</script>

<style>
  .ti-row-highlight:hover {
    background: #DFE1E5;
    opacity: 0.7;
  }
  .check-disabled[disabled] {
    opacity: 0.5; /* Firefox barely makes any visible difference when disabled.*/
  }
</style>
